import React, { useRef, useState } from "react";
import { motion } from "framer-motion";
import './Breadcrumb.css';
import { DatabaseIcon, FileIcon, HouseIcon, PackageIcon } from '@phosphor-icons/react';
import Card from "../Card/Card";
import { Copy } from "lucide-react";


const Breadcrumb = () => {
  const breadBox = useRef(null);
  const [twin, settwin] = useState(false);
  const copySnippet = () => {
    if (breadBox.current) {
      const range = document.createRange();
      range.selectNode(breadBox.current);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand("copy");
      window.getSelection().removeAllRanges();

      settwin(true);
      setTimeout(() => settwin(false), 1000);
    }
  };
  // const IconLink = () => (
  //   <a href='https://phosphoricons.com/' className="icon-link" target="_blank" rel="noopener noreferrer">
  //     https://phosphoricons.com/
  //   </a>
  // );

  return (
    <motion.div
      initial={{ y: 10, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -10, opacity: 0 }}
      transition={{ duration: 0.2 }}
    >
      <div className="Breadcrumb-wrapper">
        <br />
        <br />
        <br />
        <div className="breadcrumb">
          <span className="breadcrumb-item"><HouseIcon size={24} weight="duotone" className='icon' />Home</span>
          <span className="breadcrumb-item"><PackageIcon size={24} weight="duotone" className='icon' />Library</span>
          <span className="breadcrumb-item"><DatabaseIcon size={24} weight="duotone" className='icon' />Data</span>
          <span className="breadcrumb-item "><FileIcon size={24} weight="duotone" className='icon' /> Detail page 1</span>
        </div>

        <pre>
          <div className={`center-container ${twin ? "scanning" : ""}`}>

            <div className="snippet" ref={breadBox}>
              <pre>
                <code>
                  <span class="cn">&lt;div</span><span class="cln"> className="</span><span class="cn">breadcrumb</span><span class="cln">"&gt;</span><br />

                  &nbsp;&nbsp;<span class="cn">&lt;span</span><span class="cln"> className="</span><span class="cn">breadcrumb-item</span><span class="cln">"&gt;</span>
                  <span class="cn">&lt;HouseIcon</span> <span class="cln">size={'{'}</span><span class="cn">24</span><span class="cln">{'}'}</span> <span class="cln">weight="</span><span class="cn">duotone</span><span class="cln">"</span> <span class="cln">className='</span><span class="cn">icon</span><span class="cln">' /&gt;</span> Home &nbsp;
                  <span class="cn">&lt;/span&gt;</span><br />

                  &nbsp;&nbsp;<span class="cn">&lt;span</span><span class="cln"> className="</span><span class="cn">breadcrumb-item</span><span class="cln">"&gt;</span>
                  <span class="cn">&lt;PackageIcon</span> <span class="cln">size={'{'}</span><span class="cn">28</span><span class="cln">{'}'}</span> <span class="cln">weight="</span><span class="cn">duotone</span><span class="cln">"</span> <span class="cln">className='</span><span class="cn">icon</span><span class="cln">' /&gt;</span> Library&nbsp;
                  <span class="cn">&lt;/span&gt;</span><br />

                  &nbsp;&nbsp;<span class="cn">&lt;span</span><span class="cln"> className="</span><span class="cn">breadcrumb-item</span><span class="cln">"&gt;</span>
                  <span class="cn">&lt;DatabaseIcon</span> <span class="cln">size={'{'}</span><span class="cn">28</span><span class="cln">{'}'}</span> <span class="cln">weight="</span><span class="cn">duotone</span><span class="cln">"</span> <span class="cln">className='</span><span class="cn">icon</span><span class="cln">' /&gt;</span> Data&nbsp;
                  <span class="cn">&lt;/span&gt;</span><br />

                  &nbsp;&nbsp;<span class="cn">&lt;span</span><span class="cln"> className="</span><span class="cn">breadcrumb-item</span><span class="cln">"&gt;</span>
                  <span class="cn">&lt;FileIcon</span> <span class="cln">size={'{'}</span><span class="cn">28</span><span class="cln">{'}'}</span> <span class="cln">weight="</span><span class="cn">duotone</span><span class="cln">"</span> <span class="cln">className='</span><span class="cn">icon</span><span class="cln">' /&gt;</span> Detail page 1&nbsp;
                  <span class="cn">&lt;/span&gt;</span><br />

                  <span class="cn">&lt;/div&gt;</span>
                </code>

              </pre>
            </div>
            <button aria-label="Copy Button" onClick={copySnippet}>
              <Copy />
            </button>
          </div>
        </pre>
      </div>

      <code>
        Note: Here are the sample icons placed above. You can use any icon library of your choice.If you dont want to use icons, you can simply replace the icon tags with text.
        <br />
      </code>
    </motion.div>
  )
};

const BreadcrumbCard = () => {
  return (
    <Card
      CardTitle={<h2 className='heading-xlarge'><u>
        <b>breadcrumbs</b>
      </u></h2>}
      CardBody={<Breadcrumb />}
    />
  )
}

export default BreadcrumbCard;
